import {userGuard} from "~/router/middleware/guards";
import TarifficationReport from "~/components/pages/stat/tariffication/TarifficationReport";

export default [
    {
        path: '/stat/tariffications/report',
        name: 'tariffications.report',
        component: TarifficationReport,
        middleware: {
            permissions: ['statiz.transcribe-search.report']
        },
        beforeEnter: userGuard
    },
]


